import { PageHeader } from "@/shared/ui/PageHeader";

export function PlanPage() {
  return (
    <section>
      <PageHeader
        eyebrow="Plan"
        title="Plan vs reality"
        subtitle="Feature slice placeholder — migrate frontend/app/plan.html here."
      />
    </section>
  );
}